export default {
  props: {
    disabled: {
      type: Boolean
    }
  },
  data() {
    return {
      inProgress: false
    }
  },
  methods: {
    click() {
      this.$emit('click')
      this.inProgress = true
      setTimeout(() => {
        this.inProgress = false
      }, 200)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/form-button/form-button.js